<template>
  <section-vue class="how-it-works">
    <div class="how-it-works__container container">
      <div class="how-it-works__header">
        <h2 class="how-it-works__headline">
          {{ $t("headline") }}
        </h2>

        <div class="how-it-works__subheadline">
          {{ $t("subheadline", { maxSeats }) }}
        </div>
      </div>

      <div class="how-it-works__step" v-for="step in $options.steps" :key="step">
        <div class="how-it-works__step-count" />
        <div class="how-it-works__step-headline">
          {{ $t(`steps.${step}.headline`) }}
        </div>
        <div class="how-it-works__step-description">
          {{ $t(`steps.${step}.description`) }}
        </div>
      </div>
    </div>
  </section-vue>
</template>

<script>
import { mapState } from "vuex"
import SectionVue from "@/shared/section"

export default {
  name: "HowItWorks",
  components: {
    SectionVue
  },
  steps: ["createAccount", "checkout", "shareTeam", "seeLearn"],
  computed: {
    ...mapState("business", ["maxSeats"])
  },
  i18n: {
    messages: {
      en: {
        headline: "How it works",
        subheadline:
          "Our self-serve option for smaller groups and teams makes it quick and easy to buy Blinkist for up to {maxSeats} people at a discount.",
        steps: {
          createAccount: {
            headline: "Create your account",
            description: "Signup, create your team name, and choose your number or seats."
          },
          checkout: {
            headline: "Checkout",
            description: "Pay securely online and finish set up in minutes."
          },
          shareTeam: {
            headline: "Share with your team",
            description: "Give access to Blinkist Premium by sharing your unique invite link."
          },
          seeLearn: {
            headline: "See your team learn",
            description: "Get insight into how your team learns with your user analytics dashboard."
          }
        }
      },
      de: {
        headline: "So funktioniert’s:",
        subheadline:
          "Mit unserem Angebot für kleinere Unternehmen und Sofort-Starter können Sie Ihren Account in wenigen Schritten online einrichten und direkt loslegen.",
        steps: {
          createAccount: {
            headline: "Konto erstellen:",
            description:
              "Registrieren Sie sich, erstellen Sie Ihren Teamnamen und wählen Sie die Anzahl der Plätze Ihres Teams."
          },
          checkout: {
            headline: "Bezahlen:",
            description: "Sie zahlen sicher online und richten den Account in wenigen Minuten ein."
          },
          shareTeam: {
            headline: "Team erfreuen:",
            description:
              "Sie teilen den Zugang mit Ihrem Team über einen für Sie vorbereiteten Link und andere Vorlagen."
          },
          seeLearn: {
            headline: "Lernverhalten analysieren:",
            description:
              "Verschaffen Sie sich mit Ihrem Nutzerdaten-Analyse-Dashboard einen Überblick darüber, wie sich Ihr Team weiterbildet."
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.how-it-works {
  counter-reset: step-count;

  &__container {
    @include grid-css;
  }

  &__header {
    @include grid-css-element(12);

    margin-bottom: $spacing-32;

    text-align: center;

    @include media(min-width, m) {
      @include grid-css-element(8, 3);

      margin-bottom: $spacing-64;
    }
  }

  &__headline {
    margin-bottom: $spacing-32;
  }

  &__subheadline {
    @include font-style(p, $color: $deep-black);

    text-align: center;

    @include media(min-width, m) {
      @include font-style(p0, $color: $deep-black);
    }
  }

  &__steps {
    display: flex;
    flex-direction: column;
  }

  &__step {
    @include grid-css-element(12);

    margin-bottom: $spacing-24;

    &:last-child {
      margin-bottom: $spacing-32;
    }

    @include media(min-width, m) {
      @include grid-css-element(6);
    }

    @include media(min-width, l) {
      @include grid-css-element(3);

      margin-bottom: 0;
    }
  }

  &__step-count {
    &:before {
      @include font-style(h1);

      content: counter(step-count);

      color: $orchid-violet6;

      counter-increment: step-count;

      @include media(min-width, m) {
        margin-bottom: $spacing-8;
      }
    }
  }

  &__step-headline {
    @include font-style(h4, $midnight);

    margin-bottom: $spacing-16;
  }

  &__step-description {
    @include font-style(p1, $dark-grey);
  }
}
</style>
